import { format } from 'date-fns';

export const generateUniqueFileName = (prefix: string, name: string, fileExtension: string): string =>
  `${prefix ? prefix + '__' : ''}${name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()}__${format(
    new Date(),
    'YYYY-MM-DD_HH-mm-ss'
  )}.${fileExtension}`;
